<template>
  <div class="login">
    <div class="warp">
      <div class="isQrCode" v-if="isQrCode">
        <div class="isreset" v-if="isReset">
          <div class="islogin" v-if="isLogin">
            <Phone @close="close"></Phone>
          </div>
          <div class="islogin" v-else>
            <register></register>
          </div>
        </div>
      </div>
      <div class="close" @click="close">
        <img src="/static/login/close.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Phone from '@/components/login/phone/phone.vue'
import Captcha from '@/components/login/captcha/captcha.vue'
import Register from './register/register.vue'
import Reset from './reset/reset.vue'
import Qrcode from './qrcode/qrcode.vue'

export default {
  name: 'login',
  data () {
    return {
      isHideFun: true,
      isHide: false
    }
  },
  components: {
    Phone,
    Captcha,
    Register,
    Reset,
    Qrcode
  },
  created () {
  },
  computed: {
    isPassword () {
      return this.$store.state.login.isPasswordLogin
    },
    isLogin () {
      return this.$store.state.login.isLogin
    },
    isReset () {
      return this.$store.state.login.isReset
    },
    isQrCode () {
      return this.$store.state.login.isQrCode
    }
  },
  methods: {
    BatchesFun (e) {
      this.isHideFun = e
    },
    close () {
      this.$store.dispatch('set_ishidefun', false)
    },
    isQrCodeFunc (type) {
      if (type === 1) {
        this.$store.dispatch('set_isQrCode', false)
      } else {
        this.$store.dispatch('set_isQrCode', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./login";
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue